import { createAction } from '@reduxjs/toolkit';

export const requestCreateTeam = createAction('team/createTeam');
export const requestViewTeam = createAction('team/viewTeam');
export const requestUpdateTeam = createAction('team/updateTeam');
export const requestDeleteTeam = createAction('team/deleteTeam');
